import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { publicAxiosInstance } from './publicAxiosInstance.ts'
import type { AxiosRequestConfig, AxiosError, AxiosInstance } from 'axios'

const createPublicAxiosBaseQueryInstance = (instance: AxiosInstance) => {
    const axiosBaseQuery =
    (
        { baseUrl }: { baseUrl: string } = { baseUrl: '' }
    ): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
            headers?: AxiosRequestConfig['headers']
        },
        unknown,
        unknown
    > =>
        async ({ url, method, data, params, headers }) => {
            try {
                const result = await instance({
                    url: baseUrl + url,
                    method,
                    data,
                    params,
                    headers,
                })
                return { data: result.data }
            } catch (axiosError) {
                const err = axiosError as AxiosError
                return {
                    error: {
                        status: err.response?.status,
                        data: err.response?.data || err.message,
                    },
                }
            }
        }

        return axiosBaseQuery;
}


export const publicAxiosBaseQuery = createPublicAxiosBaseQueryInstance(publicAxiosInstance);
